import { useInfo } from "../hooks/useData";
import PersonInfo from "./Info/PersonInfo";
import useClient from "../hooks/clientStore";
import Input from "./Inputs/Input";
import Layout from "./Layout";
import NotesEditor from "./NotesEditor";
import Tasks from "./Tasks";

const ClientSettings = () => {
  const { data, setField } = useInfo();

  const notesOpen = useClient((state) => state.notesOpen);
  // const setNotesOpen = useClient((state) => state.setNotesOpen);

  return (
    <Layout page="basic">
      <div className="flex flex-col gap-6 min-h-[600px]">
        <div className="flex gap-6 w-[1600px]">
          <div className="shadow-md  bg-white p-6 rounded-lg">
            <div className="h-full">
              <div className="font-semibold text-2xl">Household</div>
              <div className="flex flex-col gap-4 mt-6">
                <Input
                  label="Household Name"
                  value={data.title}
                  size="lg"
                  subtype="text"
                  setValue={setField("title")}
                />
              </div>
              <div className="flex gap-12">
                {data.people.map((person, i) => (
                  <PersonInfo
                    key={i}
                    subtitle="Details about how this works"
                    person={person}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="shadow-md bg-white p-6 pb-20 rounded-lg min-h-[500px] min-w-[600px]">
            <div className="font-semibold text-2xl mb-4">Notes</div>
            {!notesOpen && (
              <NotesEditor
                initialContent={data.notes}
                setContent={setField("notes")}
              />
            )}
          </div>
        </div>
        <div className="flex flex-col gap-6">
          <div className="shadow-md bg-white p-6 pb-16 rounded-lg min-h-[400px] max-w-[1300px]">
            <div className="font-semibold text-2xl">Tasks</div>
            <div className="flex justify-center min-w-[1300px]">
              <Tasks
                initialTasks={data.tasks}
                client={data}
                open
                setExternal={(t: any) => {
                  if (typeof t === "function") {
                    setField("tasks")(t(data.tasks));
                  } else {
                    setField("tasks")(t);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ClientSettings;
